<!-- days calendar view mode -->
@if (viewMode | async) {
  <div class="bs-datepicker" [ngClass]="containerClass">
    <div class="bs-datepicker-container"
      [@datepickerAnimation]="animationState"
      (@datepickerAnimation.done)="positionServiceEnable()">
      <!--calendars-->
      <div class="bs-calendar-container" role="application">
        @switch (viewMode | async) {
          <!--days calendar-->
          @case ('day') {
            <div class="bs-media-container">
              @for (calendar of daysCalendar$ | async; track calendar) {
                <bs-days-calendar-view
                  [class.bs-datepicker-multiple]="multipleCalendars"
                  [calendar]="calendar"
                  [isDisabled]="isDatePickerDisabled"
                  [options]="options$ | async"
                  (onNavigate)="navigateTo($event)"
                  (onViewMode)="setViewMode($event)"
                  (onHover)="dayHoverHandler($event)"
                  (onHoverWeek)="weekHoverHandler($event)"
                  (onSelect)="daySelectHandler($event)">
                </bs-days-calendar-view>
              }
            </div>
            @if (withTimepicker) {
              <div class="bs-timepicker-in-datepicker-container">
                <timepicker #startTP [disabled]="isDatePickerDisabled"></timepicker>
                @if (isRangePicker) {
                  <timepicker #endTP [disabled]="isDatePickerDisabled"></timepicker>
                }
              </div>
            }
          }
          <!--months calendar-->
          @case ('month') {
            <div class="bs-media-container">
              @for (calendar of monthsCalendar | async; track calendar) {
                <bs-month-calendar-view
                  [class.bs-datepicker-multiple]="multipleCalendars"
                  [calendar]="calendar"
                  (onNavigate)="navigateTo($event)"
                  (onViewMode)="setViewMode($event)"
                  (onHover)="monthHoverHandler($event)"
                  (onSelect)="monthSelectHandler($event)">
                </bs-month-calendar-view>
              }
            </div>
          }
          <!--years calendar-->
          @case ('year') {
            <div class="bs-media-container">
              @for (calendar of yearsCalendar | async; track calendar) {
                <bs-years-calendar-view
                  [class.bs-datepicker-multiple]="multipleCalendars"
                  [calendar]="calendar"
                  (onNavigate)="navigateTo($event)"
                  (onViewMode)="setViewMode($event)"
                  (onHover)="yearHoverHandler($event)"
                  (onSelect)="yearSelectHandler($event)">
                </bs-years-calendar-view>
              }
            </div>
          }
        }
      </div>
      <!--applycancel buttons-->
      @if (false) {
        <div class="bs-datepicker-buttons">
          <button class="btn btn-success" type="button">Apply</button>
          <button class="btn btn-default" type="button">Cancel</button>
        </div>
      }
      @if (showTodayBtn || showClearBtn) {
        <div class="bs-datepicker-buttons">
          @if (showTodayBtn) {
            <div class="btn-today-wrapper"
              [class.today-left]="todayPos === 'left'"
              [class.today-right]="todayPos === 'right'"
              [class.today-center]="todayPos === 'center'"
              >
              <button class="btn btn-success" (click)="setToday()">{{todayBtnLbl}}</button>
            </div>
          }
          @if (showClearBtn) {
            <div class="btn-clear-wrapper"
              [class.clear-left]="clearPos === 'left'"
              [class.clear-right]="clearPos === 'right'"
              [class.clear-center]="clearPos === 'center'"
              >
              <button class="btn btn-success" (click)="clearDate()">{{clearBtnLbl}}</button>
            </div>
          }
        </div>
      }
    </div>
    <!--custom dates or date ranges picker-->
    @if (customRanges && customRanges.length > 0) {
      <div class="bs-datepicker-custom-range">
        <bs-custom-date-view
          [selectedRange]="chosenRange"
          [ranges]="customRanges"
          [customRangeLabel]="customRangeBtnLbl"
          (onSelect)="setRangeOnCalendar($event)">
        </bs-custom-date-view>
      </div>
    }
  </div>
}
